/* Sendungsverfolgung — eigenes Widget.
   Liest orderNumber + zipCode/token aus der URL, holt den Status von der
   parcel-tracking-api und rendert Status, Bestelldetails und Empfehlungen. */
(function () {
  'use strict';

  var root = document.getElementById('tracking-widget');
  if (!root) return;
  var cfg = root.dataset;
  var S = {};
  try {
    S = JSON.parse(document.getElementById('tracking-widget-i18n').textContent);
  } catch (e) {}
  function fill(str, values) {
    return String(str).replace(/\[(\w+)\]/g, function (m, key) {
      return Object.prototype.hasOwnProperty.call(values, key) ? String(values[key]) : m;
    });
  }

  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html !== undefined) e.innerHTML = html;
    return e;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function fmtDateTime(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    return d.toLocaleDateString((document.documentElement.lang || 'de-DE'), { day: '2-digit', month: 'short' }) +
      ', ' + d.toLocaleTimeString((document.documentElement.lang || 'de-DE'), { hour: '2-digit', minute: '2-digit' });
  }
  function fmtPrice(v, currency) {
    if (v == null) return '';
    try {
      return new Intl.NumberFormat((document.documentElement.lang || 'de-DE'),
        { style: 'currency', currency: currency || 'EUR' }).format(v);
    } catch (e) { return v + ' €'; }
  }

  function renderLookup(message) {
    root.innerHTML = '';
    var box = el('div', 'tw-lookup');
    box.appendChild(el('h1', '', esc(S.title)));
    box.appendChild(el('p', '', esc(S.lookupIntro)));
    if (message) box.appendChild(el('p', 'tw-error', esc(message)));
    var form = el('form');
    form.innerHTML =
      '<input name="orderNumber" inputmode="numeric" placeholder="' + esc(S.orderNumberPlaceholder) + '" required>' +
      '<input name="zipCode" inputmode="numeric" placeholder="' + esc(S.zipPlaceholder) + '" required>' +
      '<button type="submit">' + esc(S.track) + '</button>';
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var p = new URLSearchParams(window.location.search);
      p.set('orderNumber', form.orderNumber.value.trim().replace(/^#/, ''));
      p.set('zipCode', form.zipCode.value.trim());
      p.delete('token');
      window.location.search = p.toString();
    });
    box.appendChild(form);
    root.appendChild(box);
  }

  function dot(done) {
    return '<div class="tw-dot' + (done ? ' tw-done' : '') + '">' +
      (done ? '<svg viewBox="0 0 12 12" fill="none"><path d="M2 6.5 4.7 9 10 3.5" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg>' : '') +
      '</div>';
  }

  function renderShipment(s, multiIndex, total) {
    var card = el('div', 'tw-card tw-status');
    if (total > 1) {
      card.appendChild(el('div', 'tw-updated',
        fill(esc(S.packageOf), { index: multiIndex, total: total })));
    }
    card.appendChild(el('h1', '', esc(s.state_label)));
    if (s.last_update) {
      card.appendChild(el('div', 'tw-updated',
        fill(esc(S.lastUpdated), { date: esc(fmtDateTime(s.last_update)) })));
    }
    if (s.expected_delivery_date) {
      card.appendChild(el('div', 'tw-eta',
        fill(S.eta, { date: esc(s.expected_delivery_date) })));
    }
    var step = s.progress_step || 0;
    card.appendChild(el('div', 'tw-progress',
      dot(step >= 0) +
      '<div class="tw-bar' + (step >= 1 ? ' tw-done' : '') + '"></div>' +
      dot(step >= 1) +
      '<div class="tw-bar' + (step >= 2 ? ' tw-done' : '') + '"></div>' +
      dot(step >= 2)));

    var box = el('div', 'tw-statusbox');
    box.appendChild(el('h3', '', esc(S.statusHeading)));
    var latest = s.timeline && s.timeline[0];
    box.appendChild(el('div', '',
      latest ? esc(latest.text) : esc(S.preparing)));
    if (s.timeline && s.timeline.length > 1) {
      var list = el('ul', 'tw-timeline');
      s.timeline.forEach(function (t) {
        list.appendChild(el('li', '',
          '<time>' + fmtDateTime(t.ts) +
          (t.location ? ' · ' + esc(t.location) : '') + '</time>' +
          esc(t.text)));
      });
      var btn = el('button', 'tw-toggle', esc(S.showDetails));
      btn.addEventListener('click', function () {
        var open = list.classList.toggle('tw-open');
        btn.textContent = open ? S.hideDetails : S.showDetails;
      });
      box.appendChild(btn);
      box.appendChild(list);
    }
    card.appendChild(box);
    card.appendChild(el('div', 'tw-carrier',
      fill(S.carrier, {
        carrier: esc(s.carrier),
        number: '<a href="' + esc(s.tracking_url) + '" target="_blank" rel="noopener">' +
          esc(s.tracking_number) + '</a>'
      })));
    return card;
  }

  // WhatsApp-Deep-Link funktioniert nur sinnvoll auf dem Smartphone.
  function isPhone() {
    return /Android|iPhone/i.test(navigator.userAgent) ||
      (window.matchMedia && matchMedia('(pointer: coarse)').matches &&
        window.innerWidth < 750);
  }

  var WA_ICON =
    '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
    '<path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2Zm0 18.2c-1.6 0-3.1-.4-4.4-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2Zm4.6-6.1c-.3-.1-1.5-.7-1.7-.8-.2-.1-.4-.1-.6.1-.2.3-.7.8-.8 1-.1.2-.3.2-.5.1a6.7 6.7 0 0 1-3.4-3c-.3-.4 0-.5.1-.7l.4-.5c.1-.2.2-.3.3-.5v-.5c0-.1-.6-1.4-.8-1.9-.2-.5-.4-.4-.6-.4h-.5c-.2 0-.5.1-.7.3-.2.3-.9.9-.9 2.2s1 2.5 1.1 2.7c.1.2 1.9 3 4.7 4.2.7.3 1.2.5 1.6.6.7.2 1.3.2 1.8.1.6-.1 1.5-.6 1.7-1.2.2-.6.2-1.1.2-1.2-.1-.1-.2-.2-.4-.3Z"/></svg>';

  /* Kampagnen und Seiten-Config kommen aus der Chat-Console (via API);
     die Section-Settings bleiben Fallback, solange die API die Felder
     noch nicht liefert. Liefert sie sie, entscheidet allein die Console —
     auch "nichts anzeigen" ist dann eine bewusste Entscheidung. */
  function pickCampaign(list) {
    var mobile = isPhone();
    for (var i = 0; i < list.length; i++) {
      if (mobile ? list[i].mobile !== false : list[i].desktop !== false) {
        return list[i];
      }
    }
    return null;
  }

  function promoConfig(d) {
    if (Array.isArray(d.campaigns)) return pickCampaign(d.campaigns);
    if (cfg.promoHeading && d.order.first_order === true) {
      return { heading: cfg.promoHeading, text: cfg.promoText,
               code: cfg.promoCode, url: cfg.promoUrl };
    }
    return null;
  }

  function whatsappBanner(page) {
    var wa;
    if (page && page.whatsapp) {
      wa = page.whatsapp;
      if (!wa.enabled || !wa.heading || !wa.url) return null;
      if (!(isPhone() ? wa.mobile !== false : wa.desktop === true)) return null;
    } else {
      if (!cfg.waHeading || !cfg.waUrl || !isPhone()) return null;
      wa = { heading: cfg.waHeading, text: cfg.waText,
             members: cfg.waMembers, url: cfg.waUrl };
    }
    var a = el('a', 'tw-wa');
    a.setAttribute('href', wa.url);
    a.setAttribute('target', '_blank');
    a.setAttribute('rel', 'noopener');
    a.innerHTML =
      '<div class="tw-wa-icon">' + WA_ICON + '</div>' +
      '<div class="tw-wa-body"><strong>' + esc(wa.heading) + '</strong>' +
      (wa.text ? '<span>' + esc(wa.text) + '</span>' : '') +
      (wa.members ? '<em>' + esc(wa.members) + '</em>' : '') +
      '</div>' +
      '<div class="tw-wa-cta">' + esc(S.waCta) + '</div>';
    return a;
  }

  function renderData(d) {
    root.innerHTML = '';
    var wa = whatsappBanner(d.page);
    if (wa) root.appendChild(wa);
    var camp = promoConfig(d);
    var hasPromo = !!(camp && camp.heading);
    var grid = el('div', 'tw-grid' + (hasPromo ? '' : ' tw-no-promo'));

    if (hasPromo) {
      var promo = el('div', 'tw-card tw-promo');
      // Grafik aus der Console: Gerätevariante zuerst, sonst die andere.
      var imgSrc = isPhone()
        ? (camp.image_mobile || camp.image_desktop)
        : (camp.image_desktop || camp.image_mobile);
      if (imgSrc) {
        var promoImg = el('img', 'tw-promo-img');
        promoImg.src = imgSrc.indexOf('/') === 0 ? cfg.api + imgSrc : imgSrc;
        promoImg.alt = '';
        promoImg.loading = 'lazy';
        promo.appendChild(promoImg);
      }
      promo.appendChild(el('h2', '', esc(camp.heading)));
      if (camp.code) {
        var code = el('div', 'tw-promo-code', esc(camp.code));
        code.title = S.copyHint;
        code.addEventListener('click', function () {
          if (navigator.clipboard) navigator.clipboard.writeText(camp.code);
          code.textContent = S.copied;
          setTimeout(function () { code.textContent = camp.code; }, 1500);
        });
        promo.appendChild(code);
      }
      if (camp.text) promo.appendChild(el('p', '', esc(camp.text)));
      if (camp.url) {
        promo.appendChild(el('a', 'tw-promo-btn', esc(S.orderNow)))
          .setAttribute('href', camp.url);
      }
      grid.appendChild(promo);
    }

    var mid = el('div');
    d.shipments.forEach(function (s, i) {
      var c = renderShipment(s, i + 1, d.shipments.length);
      if (i > 0) c.style.marginTop = '1.6rem';
      mid.appendChild(c);
    });
    grid.appendChild(mid);

    var order = el('div', 'tw-card tw-order');
    order.appendChild(el('h2', 'tw-heading', esc(S.orderDetails)));
    order.appendChild(el('span', 'tw-chip', fill(esc(S.orderName), { name: esc(d.order.name) })));
    d.order.products.forEach(function (p) {
      var item = el('div', 'tw-item');
      item.innerHTML =
        (p.image_url
          ? '<img src="' + esc(p.image_url) + '" alt="" loading="lazy">'
          : '<div class="tw-item-ph"></div>') +
        '<div class="tw-item-name">' + esc(p.name) +
        '<small>' + esc(p.variant_name === 'Default Title' ? '' : p.variant_name || '') +
        (p.quantity > 1 ? ' · ' + fill(esc(S.quantity), { quantity: p.quantity }) : '') + '</small></div>' +
        (p.price != null
          ? '<div>' + fmtPrice(p.price * (p.quantity || 1), d.order.currency) + '</div>'
          : '');
      order.appendChild(item);
    });
    if (d.order.total != null) {
      order.appendChild(el('div', 'tw-total',
        '<span>' + esc(S.total) + '</span><span>' +
        fmtPrice(d.order.total, d.order.currency) + '</span>'));
    }
    if (d.order.masked_address && d.order.masked_address.length) {
      var addr = el('div', 'tw-address');
      addr.appendChild(el('h3', '', esc(S.shippingAddress)));
      d.order.masked_address.forEach(function (line) {
        addr.appendChild(el('p', '', esc(line)));
      });
      order.appendChild(addr);
    }
    if (cfg.faqUrl) {
      var faq = el('a', 'tw-faq', esc(S.faq));
      faq.setAttribute('href', cfg.faqUrl);
      order.appendChild(faq);
    }
    grid.appendChild(order);
    root.appendChild(grid);

    if (cfg.showRecs === 'true' && d.recommendations && d.recommendations.length) {
      // Mi!-Avatar mit Sprechblase leitet die Empfehlungen ein. Text kommt
      // aus der Console (d.page), sonst aus den Section-Settings.
      var avatarText = d.page ? (d.page.avatar_text || '') : (cfg.avatarText || '');
      if (cfg.avatarUrl && avatarText) {
        var mi = el('div', 'tw-mi');
        mi.innerHTML =
          '<img src="' + esc(cfg.avatarUrl) + '" alt="Mi!" loading="lazy">' +
          '<div class="tw-mi-bubble"><strong>' + esc(S.miRecommends) + '</strong>' +
          esc(avatarText) + '</div>';
        root.appendChild(mi);
      } else {
        root.appendChild(el('h2', 'tw-heading tw-recs-heading',
          esc(S.recsHeading)));
      }
      var recs = el('div', 'tw-recs');
      var rg = el('div', 'tw-recs-grid');
      d.recommendations.forEach(function (r) {
        // Gibt es zum Produkt ein Video, laeuft es EINMAL stumm in der Kachel
        // und blendet danach weich aufs Produktbild ab. Dafuer liegen beide
        // uebereinander: das Bild unten, das Video darueber — am Ende wird nur
        // das Video ausgeblendet. Das ist zugleich der Fallback, wenn das
        // Video gar nicht laedt. muted + playsinline direkt im Markup ist
        // Pflicht, sonst spielt iOS ohne Nutzergeste nicht an.
        var media = r.video
          ? '<div class="tw-rec-media">' +
            '<img src="' + esc(r.image || r.video_poster) + '" alt="" loading="lazy">' +
            '<video class="tw-rec-video" src="' + esc(r.video) + '" poster="' +
            esc(r.video_poster || r.image) + '" muted playsinline ' +
            'webkit-playsinline preload="none"></video></div>'
          : '<img src="' + esc(r.image) + '" alt="" loading="lazy">';
        var a = el('a', 'tw-rec',
          '<div class="tw-rec-img">' +
          (r.badge ? '<span class="tw-rec-badge' +
            (r.reason === 'replenishment_due' ? ' tw-rec-badge--replenish' : '') +
            '">' + esc(r.badge) + '</span>' : '') +
          media + '</div>' +
          '<div class="tw-rec-name">' + esc(r.title) + '</div>' +
          '<div class="tw-rec-price">' + esc(r.price) + '</div>');
        a.setAttribute('href', r.url);
        rg.appendChild(a);
      });
      recs.appendChild(rg);
      root.appendChild(recs);
      playRecVideos(rg);
    }
  }

  // Empfehlungs-Videos: erst laden und abspielen, wenn die Kachel sichtbar
  // ist, beim Wegscrollen wieder pausieren — sonst zoegen bis zu fuenf Videos
  // gleichzeitig Daten. Jedes Video laeuft genau EINMAL (6-10 s) und blendet
  // dann aufs Produktbild darunter ab; danach wird es nicht mehr beobachtet,
  // es startet also auch beim Zurueckscrollen nicht neu. Bei einem Fehler
  // wird sofort abgeblendet — darunter liegt ja das Bild.
  // Ohne IntersectionObserver (alte Browser) laufen sie schlicht sofort los.
  function playRecVideos(grid) {
    var vids = grid.querySelectorAll('video');
    if (!vids.length) return;
    var io = window.IntersectionObserver ? new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.preload = 'auto';
          var pl = e.target.play();
          if (pl && pl.catch) pl.catch(function () {});
        } else {
          e.target.pause();
        }
      });
    }, { threshold: 0.4 }) : null;
    Array.prototype.forEach.call(vids, function (v) {
      v.muted = true;
      function fadeToImage() {
        v.classList.add('tw-done');
        if (io) io.unobserve(v);
      }
      v.addEventListener('ended', fadeToImage);
      v.addEventListener('error', fadeToImage);
      if (io) io.observe(v);
      else { v.preload = 'auto'; var pl = v.play(); if (pl && pl.catch) pl.catch(function () {}); }
    });
  }

  var params = new URLSearchParams(window.location.search);
  var orderNumber = (params.get('orderNumber') || '').replace(/^#/, '');
  var zip = params.get('zipCode') || '';
  var token = params.get('token') || '';

  if (!orderNumber || (!zip && !token)) {
    renderLookup();
    return;
  }

  root.innerHTML = '<div class="tw-loading">' + esc(S.loading) + '</div>';
  var url = cfg.api + '/track?orderNumber=' + encodeURIComponent(orderNumber) +
    (token ? '&token=' + encodeURIComponent(token) : '') +
    (zip ? '&zipCode=' + encodeURIComponent(zip) : '');
  fetch(url)
    .then(function (r) {
      if (r.status === 404) {
        renderLookup(S.notFound);
        return null;
      }
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    })
    .then(function (d) { if (d) renderData(d); })
    .catch(function () {
      renderLookup(S.unavailable);
    });
})();

/* sync-touch */
